module.exports = __webpack_public_path__ + "img/cooperation_unit_02.70d4e97a.png";